export default "__VITE_ASSET__DBNuoWTv__"